export default __webpack_public_path__ + "static/media/ticket-open.0a883a2d.svg";